import { render, staticRenderFns } from "./supplierProductCompare.vue?vue&type=template&id=08f857c5&"
import script from "./supplierProductCompare.vue?vue&type=script&lang=js&"
export * from "./supplierProductCompare.vue?vue&type=script&lang=js&"
import style0 from "./supplierProductCompare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports